import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5082606c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options-list bagsize-options" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bagsize-note hide-mobile" }, [
  /*#__PURE__*/_createTextVNode(" ※タイプ選択にてマジかるベルトのセットをご選択いただくと、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"12px"} }, "単品購入（7,700円）よりも2,200円お得に本体同系色のスタンダードタイプベルトがセット"),
  /*#__PURE__*/_createTextVNode("になります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※マジかるベルトはシミュレータ上に反映されません。予めご了承ください。 ")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bagsize-note hide-mobile" }, [
  /*#__PURE__*/_createTextVNode(" 外寸：高さ35.0cm × 幅26.0cm × 奥行20.5cm"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" メイン収納部：高さ32.0cm × 幅23.5cm × 奥行12.5cm"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 小マチ内寸：高さ25.0cm × 幅23.5cm × 奥行3.0cm（MAX5.0cm）"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 重量：1,280g前後"),
  /*#__PURE__*/_createElementVNode("br")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormOption = _resolveComponent("FormOption")!
  const _component_FormTab = _resolveComponent("FormTab")!

  return (_openBlock(), _createBlock(_component_FormTab, {
    class: "bagsize-content",
    index: _ctx.index
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
          return (_openBlock(), _createBlock(_component_FormOption, {
            optionType: 'bagsize',
            key: item.id,
            option: item,
            onClick: ($event: any) => (_ctx.onClick(item)),
            isSelected: _ctx.currentSelection == item.id
          }, null, 8, ["option", "onClick", "isSelected"]))
        }), 128))
      ]),
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }, 8, ["index"]))
}